module.exports = __webpack_public_path__ + "static/media/new-app-en.0a5288ea.webp";